<div class="modal" *ngIf="isConfirmationVisible">
    <div class="modal-content">
        <div class="container">
            <div class="row">
                <div class="col-md-12 d-flex flex-column">
                    <div style="font-size: x-large; text-align: center; height: 6rem;">
                        <img class="img_success_style" *ngIf="isLoading" src="../../../assets/images/Spinner/spinnerBlue.png"
                        alt="Loading Spinner">
                        <svg *ngIf="isError" height="100" width="100">
                          <image xlink:href="../../../assets/images/Spinner/ErrorIcon.svg" x="0" y="0" height="100%" width="100%" />
                      </svg>
                        <svg *ngIf="isSuccess" height="100" width="100">
                            <image xlink:href="../../../assets/images/Spinner/SuccessIcon.svg" x="0" y="0" height="100%" width="100%" />
                        </svg>
                    </div>
                    <div class="mt-4" style="font-size: larger; text-align: center;">
                        <b>{{ confirmationMessage || 'Caricamento in corso...' }}</b>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal" *ngIf="isOperationVisible">
  <div class="modal-content col-md-12 d-flex flex-column justify-content-between align-items-center">
    <div class="col-md-12 d-flex justify-content-center" style="font-size: x-large;">
      <b style="color: orange; font-size: xx-large;">{{ 'AttentionU' | translate }}</b>
    </div>
    <div class="col-md-12 d-flex p-4 overflow-y-auto align-items-center" style="font-size: x-large; text-align: center; height: 15rem">
      <b [innerHTML]="confirmationMessage" style="overflow-wrap: break-word; word-break: break-word;"></b>
    </div>
    <div class="col-md-12 d-flex justify-content-center mt-3">
      <div class="col-md-6 d-flex justify-content-end px-2" style="border: none;" *ngIf="!isShowButtonConfirm">
        <button type="button" class="btn btn_style_back" (click)="cancelButton()">{{ 'Cancel' | translate }}</button>
      </div>
      <div class="col-md-6 d-flex px-2" [ngClass]="{'justify-content-center': isShowButtonConfirm, 'justify-content-start': !isShowButtonConfirm}">
        <button type="button" class="btn btn_style_confirm" (click)="confirmButton()">{{ 'Confirm' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" *ngIf="isCustomMessageVisible">
  <div class="modal-content col-md-12 d-flex flex-column justify-content-between align-items-center" style="width: 45rem; max-width: 45rem;">
    <div class="col-md-12 d-flex justify-content-center" style="font-size: x-large;">
      <b style="color: orange; font-size: xx-large;">{{ 'AttentionU' | translate }}</b>
    </div>
    <div class="col-12 d-flex flex-column px-4 my-2">
      <div class="col-12">
        <label class="fw-bold fs-4">Total operation: {{ information.total }}</label>
      </div>
      <div class="col-12">
        <label class="fw-bold fs-4">Successed operation: {{ information.successed }}</label>
      </div>
      <div class="col-12">
        <label class="fw-bold fs-4">Failed operation: {{ information.failed }}</label>
      </div>
    </div>
    <div class="col-md-12 d-flex p-4 overflow-y-auto align-items-start" style="font-size: x-large; text-align: center; height: 25rem">
      <b [innerHTML]="confirmationMessage" style="overflow-wrap: break-word; word-break: break-word;"></b>
    </div>
    <div class="col-md-12 d-flex justify-content-center mt-3">
      <div class="col-md-6 d-flex justify-content-end px-2" style="border: none;" *ngIf="!isShowButtonConfirm">
        <button type="button" class="btn btn_style_back" (click)="cancelButton()">{{ 'Cancel' | translate }}</button>
      </div>
      <div class="col-md-6 d-flex px-2" [ngClass]="{'justify-content-center': isShowButtonConfirm, 'justify-content-start': !isShowButtonConfirm}">
        <button type="button" class="btn btn_style_confirm" (click)="confirmButton()">{{ 'Confirm' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" *ngIf="isErrorCustom">
  <div class="modal-content col-md-12 d-flex flex-column justify-content-between align-items-center">
    <div class="col-md-12 d-flex justify-content-center" style="font-size: x-large;">
      <b style="color: orange; font-size: xx-large;">{{ 'AttentionU' | translate }}</b>
    </div>
    <div class="col-md-12 d-flex px-4 py-2 overflow-y-auto align-items-start" style="font-size: x-large; text-align: center; height: 15rem">
      <label [innerHTML]="confirmationMessage" style="overflow-wrap: break-word; word-break: break-word; width: 100%;"></label>
    </div>
    <div class="col-md-12 d-flex justify-content-center mt-3">
      <div class="col-md-6 d-flex justify-content-center" >
        <button type="button" class="btn btn_style_confirm" (click)="confirmButton()">{{ 'Confirm' | translate }}</button>
      </div>
    </div>
  </div>
</div>
